// AIDEV-NOTE: Fail-closed flag gating the orphaned-chunk rescue scan. The scan
// walks the whole IndexedDB chunks store, so it stays off by default and is
// enabled per-practitioner via the "Recording Chunk Recovery" segment while we
// validate it against a real affected device. The underlying primary-key read
// fix in durable-audio-recorder-db.ts is NOT gated — it is a correctness fix
// that applies to everyone.
export const ENABLE_RECORDING_CHUNK_RECOVERY_FLAG =
    "enable-recording-chunk-recovery";
